module.exports = __webpack_public_path__ + "img/ic_link_points.4eb0e546.svg";